import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { useField, useFormikContext } from 'formik';
import { AutocompleteTextbox } from 'react-ghost-text';
import { useAutocompleteMutation } from 'store/services/utility';
import { useParams } from "react-router-dom";
import { CHATTER_CONSULTATION_PLANT_REPORT_QUESTIONS } from "config/constants";

const QuestionAutocomplete = ({ fieldName, value, question }) => {
  const answerFieldName = `${fieldName}.answer`;

  const { assessmentId } = useParams();
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(answerFieldName);

  const [trigger] = useAutocompleteMutation();

  // State to handle internal input value and flag for initial load
  const [inputValue, setInputValue] = useState('');
  const [isInitialValueSet, setIsInitialValueSet] = useState(false); // Flag for initial value usage

  // Set the initial value only once if value.answer is not undefined
  useEffect(() => {
    if (!isInitialValueSet && value?.answer !== undefined) {
      setInputValue(value.answer);  // Use value.answer for the first time
      setIsInitialValueSet(true);   // Mark as used
    }
  }, [value?.answer, isInitialValueSet]);

  // Debounced function to get suggestions
  const getSuggestions = async (input) => {
    if (!input) return '';
    try {

      const type = question?.question == "Recommendations"
        ? "recommendation"
        : question?.id == CHATTER_CONSULTATION_PLANT_REPORT_QUESTIONS.program_description ? "program" : "";

      const payload = {
        search: input,
        type,
        assessment_type: assessmentId,
        question_id: question.id,
      }
      const response = await trigger(payload).unwrap();
      let suggestion = "";
      if(typeof response?.data == "string") {
        suggestion = response?.data;
      } else if(typeof response?.data?.answer !== "undefined") {
        suggestion = response?.data?.answer;
      }

      return !isEmpty(suggestion) ? suggestion.slice(input.length) : '';

    } catch (err) {
      console.error("Error getting recommendation suggestion", err);
      return '';
    }
  };

  // Handle input changes and update both local state and Formik field value
  const handleContentChange = (content) => {
    const sanitizedContent = content?.replace(/<\/?[^>]+(>|$)/g, "").replace(/&lt;/g, "<")?.replace(/&gt;/g, ">");
    setFieldValue(answerFieldName, sanitizedContent);  // Sync with Formik state
  };

  return (
    <>
      <div style={{ position: 'relative' }}>
        <AutocompleteTextbox
          debounceTime={300}
          getSuggestion={getSuggestions}
          value={inputValue}  // Controlled value
          onContentChange={handleContentChange}  // Sync internal and Formik state
          className="form-control rounded-3 bg-white is-resizable-textarea"
          style={{
            minHeight: "calc(6em + 0.75rem + calc(var(--bs-border-width) * 2))",
            overflowY:"auto"
          }}
          onPaste={(event) => {
            event.preventDefault();
            const plainText = event.clipboardData.getData("text/plain");
            document.execCommand("insertText", false, plainText);
          }}
        />
      </div>
      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </>
  );
};

export default QuestionAutocomplete;
